<template>
  <div class="nps-card">
    <div class="nps-card-title">{{ title }}</div>
    <div v-for="item in normalizedItems" :key="item.label" class="bar-row">
      <div class="bar-label">{{ item.label }}</div>
      <div class="bar-track">
        <div class="bar-fill" :style="{ width: `${item.width}%`, background: item.color || '#E94560' }"></div>
      </div>
      <div class="bar-value">{{ item.displayValue }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaHorizontalBarsCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  computed: {
    normalizedItems () {
      let max = 0;
      this.items.forEach((item) => {
        if (item.value > max) {
          max = item.value;
        }
      });

      return this.items.map((item) => Object.assign({}, item, {
        width: max > 0 ? (item.value / max) * 100 : 0
      }));
    }
  }
};
</script>

<style scoped>
.nps-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  min-height: 320px;
  padding: 20px 22px;
}

.nps-card-title {
  color: var(--text-primary, #1A1A2E);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 14px;
}

.bar-row {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}

.bar-label {
  color: var(--text-primary, #1A1A2E);
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 140px;
}

.bar-track {
  background: #EEF0F5;
  border-radius: 4px;
  flex: 1;
  height: 16px;
  overflow: hidden;
}

.bar-fill {
  border-radius: 4px;
  height: 100%;
  transition: width 0.4s ease;
}

.bar-value {
  color: var(--text-primary, #1A1A2E);
  font-size: 12px;
  font-weight: 700;
  width: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/HorizontalBarsCard.vue